const API_PROD =
  "https://ignouteeru-service-xwam.onrender.com/ignouteeresultupdates/api/v1/user/subscribe";

module.exports = { API_PROD };
